import axios from './axios'
import matchDomainName from '@/assets/js/matchDomainName.js';
const testUrl = matchDomainName.test();
const productionUrl = matchDomainName.production();
//工作台->预约->保存预约接口
export const reserveSave = function (params) {
  return axios.post('/reserve/save', params);
}
//工作台->预约->获取预约列表接口
export const getReserveList = function (params) {
  return axios.post('/mua/reserve/list', params);
}

//工作台->预约->拖动修改预约
export const reserveDrag = function (params) {
  return axios.post('/mua/reserve/drag', params);
}

//工作台->预约->编辑数据查询
export const reserveToEdit = function (params) {
  return axios.post('/mua/reserve/toEdit', params);
}
//工作台->预约->删除预约
export const reserveDel = function (params) {
  return axios.post('/mua/reserve/del', params);
}

// 生成消耗单
export const createServeOrderByReserveIdwx = function (reserveId) {
  return axios.post(`/order/createServeOrderByReserveId/${reserveId}`);
}


//工作台->预约->预约日期标识
export const getDateTimeFlag = function (params) {
  return axios.post('/mua/reserve/getDateTimeFlag', params);
}

//工作台->预约->预约来源
export const dictdata = function (params = {}) {
  return axios.post(`/mua/combox/sys_reserve_header_method/dictdata`, params);
}
//工作台->预约->预约对象
export const getReserveObj = function (params = {}) {
  return axios.post(`/mua/reserve/getReserveObj`, params);
}

//工作台->预约->员工列表信息
export const getStaffInfo = function (params = {}) {
  return axios.post(`/mua/reserve/getStaffInfo`, params);
}
//工作台->预约->员工列表信息
export const setStaffInfo = function (params = {}) {
  return axios.post(`/mua/reserve/saveStaffInfo`, params);
}

//工作台-》预约-》选择其他店员工
export const selectOtherStoresStaff = function (params = {}) {
  return axios.post(`/mua/order/selectOtherStoresStaff`, params);
}



//工作台-》预约-》产生订单
export const createServeOrderByReserveId = function (reserveId, params = {}) {
  return axios.post(`/mua/order/createServeOrderByReserveId/${reserveId}`, params);
}

//工作台-》今日到店-》查询会员
export const getMemberInfo = function (id, params = {}) {
  return axios.post(`/mua/member/info/${id}`, params);
}


//客情-》生日提醒
export const Birthdaynotify = function (params = {}) {
  return axios.post(`/crm/birthdaynotify`, params);
}
//客情-》回访提醒
export const Crmtasklist = function (params = {}) {
  return axios.post(`/crm/crmtasklist`, params);
}

//客情-》历程
export const Membertimeline = function (params = {}) {
  return axios.post(`/crm/membertimeline`, params);
}
//删除回访
export const delReminder = function (params = {}) {
  return axios.post(`/backVisitTemplate/delReminder`, params);
}
export const backVisitTemplateList = function (params = {}) {
  return axios.post(`/backVisitTemplate/list`, params);
}
export const createreminder = function (params = {}) {
  return axios.post(`/crm/createreminder`, params);
}


//客情-》获取会员信息
export const getCrmMemberInfo = function (params = {}) {
  return axios.post(`/crm/memberInfo`, params);
}

//客情-》获取会员消费记录
export const getCrmMemberconsumerecord = function (params = {}) {
  return axios.post(`/crm/memberconsumerecord`, params);
}
//客情-》会员沟通记录列表
export const getCrmFindinterationlist = function (params = {}) {

  return axios.post(`/crm/findinterationlist`, params, true);
}

//客情-》添加会员
export const getMemberList = function (params = {}) {
  return axios.post(`/member/list`, params);
}
//客情-》添加会员(包括其他门店)
export const getlistByOrgId = function (params = {}) {
  return axios.post(`/member/listByOrgId`, params);
}
//图片上传 添加图片-》
export const getPicresourceList = function (params = {}) {
  return axios.post(`picresource/list`, params);
}



//客情-》查询用户沟通记录
export const getCrmMemberinteraction = function (params = {}) {
  return axios.post(`/crm/memberinteraction`, params);
}
//客情-》用户头像
export const getStaffHeadPortrait = function (params = {}) {
  return axios.post(`/crm/getStaffHeadPortrait`, params);
}

//收货地址
export const getAdressList = function (params = {}) {
  return axios.post(`/address/list`, params);
}
export const saveAdress = function (params = {}) {
  return axios.post(`/address/save`, params);
}
export const delAdress = function (id, params = {}) {
  return axios.post(`/address/delete/${id}`, params);
}
export const getAddressInfo = function (addressId, params = {}) {
  return axios.post(`/address/info/${addressId}`, params);
}
export const getAddressDefault = function (addressId, params = {}) {
  return axios.post(`/address/default`, params);
}
export const createOrderShippmentAddress = function (params = {}) {
  return axios.post(`/mkt/createOrderShippmentAddress`, params);
}




export const extract = () => {
  let Link = ''
  if (process.env.NODE_ENV === 'production') {
    if (testUrl.flag) {
      Link = 'http://csportal.hxmxfj.com/extract/'
    }
    if (productionUrl.flag) {
      Link = 'http://portal.hxmxfj.com/extract/'
    }
  }

  return Link;
}


//客情-》图片上传
export const phoneUploadImage = function (params = {}) {
  return axios.post(`picresource/upload`, params);
}
// 图片上传
export const directupload = function (params = {}) {
  return axios.post(`picresource/directupload`, params);
}
//今日到店会员  新增  修改图片
export const storeMemberAddPhotos = function (params = {}) {
  return axios.post(`/memberMediaMain/saveMemberMedia`, params);
}
//今日到店会员   查询资料
export const getStoreMember = function (id, params = {}) {
  return axios.post(`/member/info/${id}`, params);
}
//今日到店会员   修改资料
export const storeMemberModify = function (params = {}) {
  return axios.post(`/member/updateMember`, params);
}
//查看所有图片
export const storeMemberAllPhotos = function (params = {}) {
  return axios.post(`/memberMediaMain/listGroupByDay`, params);
}
//删除当前行图片
export const deleteCurRowPhotos = function (params = {}) {
  return axios.post(`/memberMediaMain/delMemberMediaMain`, params);
}
//跳转获取当前行数据
export const getCurRowData = function (params = {}) {
  return axios.post(`/memberMediaMain/getMemberMediaMainFullInfo`, params);
}
//根据图片id对比图片
export const compareSelectPhotos = function (params = {}) {
  return axios.post(`/memberMediaMain/getMemberMediaUrlByIds`, params);
}
//查看发送的对比图片
export const memberMediaCompare = function (params = {}) {
  return axios.post(`/memberMediaChooseRecord/fullInfo`, params);
}
//查看发送的单张图片
export const memberMediaSingleImg = function (params = {}) {
  return axios.post(`/memberMediaMain/getMemberMediaUrl`, params);
}
//客情-》 发送信息
export const sendCrmmessage = function (params = {}) {
  return axios.post(`/crm/sendcrmmessage`, params, false);
}

//客情-》 营销活动-》 千人千面列表
export const getFormwork = function (params = {}) {
  return axios.post(`/formworkInstance/list`, params, false);
}
// 千人千面列表模板
export const getFormworkTemp = function (params = {}) {
  return axios.post(`/formwork/list`, params, false);
}

//到店-》 二维码查询
export const getQrCode = function (params = {}) {
  return axios.post(`mua/org/getQrCode`);
}

//聊天链接
export const WebSocketLink = () => {
  let Link = ''
  let reg = /^https/ig;

  // if (process.env.NODE_ENV === 'production') {
  if (testUrl.flag) {
    reg.test(testUrl.hostname) ? (Link = 'wss://cswebsocket.hxmxfj.com') : (Link = 'ws://cswebsocket.hxmxfj.com')
  }
  if (productionUrl.flag) {
    reg.test(productionUrl.hostname) ? (Link = 'wss://websocket.hxmxfj.com') : (Link = 'ws://websocket.hxmxfj.com')
  }
  // } else {
  //   Link  = 'ws://websocket.hxmxfj.com'
  // }
  console.log('Link')
  console.log(Link)
  return Link;
}

//弹幕链接
export const WebSocketBarrageLink = () => {
  let Link = 'wss://cswebsocket.hxmxfj.com'
  let reg = /^https/ig;

  // if (process.env.NODE_ENV === 'production') {
  if (testUrl.flag) {
    reg.test(testUrl.hostname) ? (Link = 'wss://cswebsocket.hxmxfj.com') : (Link = 'ws://cswebsocket.hxmxfj.com')
  }
  if (productionUrl.flag) {
    reg.test(productionUrl.hostname) ? (Link = 'wss://websocket.hxmxfj.com') : (Link = 'ws://websocket.hxmxfj.com')
  }
  // } else {
  //   Link  = 'ws://websocket.hxmxfj.com'
  // }
  console.log('Link')
  console.log(Link)
  return Link;
}



//用户静默授权
export const checkUserAuthorize = (orgId) => {
  let Link = ''
  let reg = /^https/ig;
  // 'https://csm.hxmxfj.com/m/auth/check/1506?url='
  // if (process.env.NODE_ENV === 'production') {
  if (testUrl.flag) {
    reg.test(testUrl.hostname) ? (Link = 'https://csm.hxmxfj.com/m/auth/check/' + orgId + '?url=') : (Link = 'http://csm.hxmxfj.com/m/auth/check/' + orgId + '?url=')
  }
  if (productionUrl.flag) {
    reg.test(productionUrl.hostname) ? (Link = 'https://m.hxmxfj.com/m/auth/check/' + orgId + '?url=') : (Link = 'http://m.hxmxfj.com/m/auth/check/' + orgId + '?url=')
  }

  return Link;
}

//用户授权
export const infocheckLink = (orgId) => {
  let Link = ''
  let reg = /^https/ig;
  // 'https://csm.hxmxfj.com/m/auth/check/1506?url='
  // if (process.env.NODE_ENV === 'production') {
  if (testUrl.flag) {
    reg.test(testUrl.hostname) ? (Link = 'https://csm.hxmxfj.com/m/auth/infocheck/' + orgId + '?url=') : (Link = 'http://csm.hxmxfj.com/m/auth/infocheck/' + orgId + '?url=')
  }
  if (productionUrl.flag) {
    reg.test(productionUrl.hostname) ? (Link = 'https://m.hxmxfj.com/m/auth/infocheck/' + orgId + '?url=') : (Link = 'http://m.hxmxfj.com/m/auth/infocheck/' + orgId + '?url=')
  }

  return Link;
}


//美丽在线授权
export const mlzxcheckLink = () => {
  let Link = ''
  let reg = /^https/ig;

  // if (process.env.NODE_ENV === 'production') {
  if (testUrl.flag) {
    reg.test(testUrl.hostname) ? (Link = 'https://csm.hxmxfj.com/m/auth/mlzxcheck?url=') : (Link = 'http://csm.hxmxfj.com/m/auth/mlzxcheck?url=')
  }
  if (productionUrl.flag) {
    reg.test(productionUrl.hostname) ? (Link = 'https://m.hxmxfj.com/m/auth/mlzxcheck?url=') : (Link = 'http://m.hxmxfj.com/m/auth/mlzxcheck?url=')
  }

  return Link;
}




//开始抽奖
export const lotteryDraw = function (params = {}) {
  return axios.post(`/lottery/draw`, params, false);
}

//查询用户记录
export const getPluginLotteryMemberRecord = function (params = {}) {
  return axios.post(`/lottery/getPluginLotteryMemberRecord`, params, false);
}

//获取奖品抽奖
const getLottery = (params = {}) => {
  // return axios.post(`/lottery/getLotteryById`,params);
}
//查询用户记录
export const getLotteryById = function (params = {}) {
  return axios.post(`/lottery/getLotteryById`, params);
}






//拼团商城首页
export const groupAllgroup = function (params = {}) {
  return axios.post(`group/allgroup`, params);
}
//拼团我的团
export const groupMyCreateGroup = function (params = {}) {
  return axios.post(`/group/myGroup`, params);
}
//拼团详情
export const groupInfo = function (id, params = {}) {
  return axios.post(`/group/info/${id}`, params);
}
// 更多
export const getGroupBuyInfoByPluginId = function (params = {}) {
  return axios.post(`/group/getGroupBuyInfoByPluginId`, params);
}
// 更多
export const commentList = function (params = {}) {
  return axios.post(`comment/list`, params);
}

//创建开团订单
export const groupCreategp = function (params = {}) {
  return axios.post(`group/creategp`, params);
}
// 开团轮播图
export const groupBaseInfo = function (params = {}) {
  return axios.post(`/group/baseInfo`, params);
}



// 投票主页列表查询
export const voteparterlist = function (params = {}) {
  return axios.post(`/vote/voteparterlist`, params);
}





//提现
export const getAlipayAccount = function (params = {}) {
  return axios.post(`/member/getAlipayAccount`, params);
}
export const savealipayAccount = function (params = {}) {
  return axios.post(`/member/savealipayAccount`, params);
}
export const recCash = function (params = {}) {
  return axios.post(`/receivecash/recCash`, params);
}
export const getReturnCashList = function (params = {}) {
  return axios.post(`/receivecash/getReturnCashList`, params);
}
export const memberWithdraw = function (params = {}) {
  return axios.post(`/extract/withdrawOrderInfo`, params);
}

/*确认修复*/
export const repairCash = function (params = {}) {
  return axios.post(`/receivecash/repairCash`, params);
}

//获取推文
export const getPlugin = function (pluginId, params = {}) {
  return axios.post(`/plugin/info/${pluginId}`, params);
}

//礼物
export const getGift = function (params = {}) {
  return axios.post(`/gift/getGiftDefineById`, params);
}
export const receiveGift = function (params = {}) {
  return axios.post(`/gift/receive`, params);
}
export const giftMemberList = function (params = {}) {
  return axios.post(`/gift/giftMemberList`, params);
}

//领导
export const zeropayconfirm = function (orderId, params = {}) {

  return axios.post(`/order/zeropayconfirm/${orderId}`, params);
}


//获取验证码
export const getverificationcode = function (params = {}) {
  return axios.post("/member/getverificationcode", params);
}

//保存手机号码接口
export const savemobileno = function (params = {}) {
  return axios.post("/member/savemobileno", params);
}

//中奖保存地址
export const saveLotteryShippmentAddress = function (params = {}) {
  return axios.post("/lottery/saveLotteryShippmentAddress", params);
}

//商城mall
export const getMallList = function (params = {}) {
  return axios.post("shopping/list", params);
}
export const shoppingCreate = function (params = {}) {
  return axios.post("shopping/create", params);
}
export const getMallDetail = function (params = {}) {
  return axios.post("/shopping/getPluginShoppingById", params);
}
//商城分享次数获取礼物
export const getMallShareGift = function (params = {}) {
  return axios.post("plugin/getPluginShareRead", params);
}

//疯狂拓客 tuoke
export const getTuokeList = function (params = {}) {
  return axios.post("/pluginExpcustomer/list", params);
}
export const submitBuyCreate = function (params = {}) {
  return axios.post("pluginExpcustomer/submitBuy", params);
}
export const getTuokeDetail = function (id, triggerEventId) {
  let params = {
    triggerEventId: triggerEventId
  }
  return axios.post(`/pluginExpcustomer/getFullInfo/${id}`, params);
}

//个人资料
export const getuMemberInfo = function (id, params = {}) {
  return axios.post(`/member/info/${id}`, params);
}
//更新会员信息
export const memberUpdate = function (params = {}) {
  return axios.post("/member/update", params);
}
//查看会员下级
export const memberChildren = function (params = {}) {
  return axios.post("/member/childMember", params);
}
//数据字典
export const getDataRequest = function (category, params = {}) {
  return axios.get(`/combox/${category}/dictdata`, params);
}
//营销方案
export const plankpi = function (status, params = {}) {
  return axios.post(`/plugin/plankpi/${status}`, params);
}
// export const plankpi = function (params = {}) {
//   return axios.post(`/plugin/plankpi`, params);
// }
export const pluginkpi = function (planid, orgId, type, params = {}) {
  return axios.post(`/plugin/pluginkpi/${planid}/${orgId}/${type}`, params);
}
export const plansharekpi = function (planid, params = {}) {
  return axios.post(`/plugin/plansharekpi/${planid}`, params);
}
export const shopPlankpi = function (planid, params = {}) {
  return axios.post(`/plugin/plankpi/currentorg/${planid}`, params);
}
//消费记录
export const memberconsumerecord = function (params = {}) {
  return axios.post(`/member/memberconsumerecord`, params);
}
//消费类型
export const pluginTypeDictdata = function (params = {}) {
  return axios.get(`/combox/sys_plugin_type/dictdata`, params);
}

//营销方案列表查询
export const pluginList = function (params = {}) {
  return axios.post(`/plugin/list`, params);
}


//会员信息查询
export const memberInfo = function (id, params = {}) {

  return axios.post(`/member/info/${id}`, params);
}

//营销方url查询
export const getPluginUrl = function (params = {}) {

  return axios.post(`plugin/getPluginUrl/`, params);
}

//抽奖输入手机或者地址之后领取奖品
export const bindAndReceive = function (params = {}) {
  return axios.post(`/lottery/bindAndReceive`, params);
}
//预约
export const getMemberReserveInfo = function (params = {}) {
  return axios.post(`/reserve/getMemberReserveInfo`, params);
}
//预约  广告图
export const checkplanForAd = function (params) {
  return axios.post(`/mkt/checkplanForAd/${params}`);
}
//查询被预约的时间
export const getReserveRecordInfo = function (params = {}) {
  return axios.post(`/reserve/getReserveRecordInfo`, params);
}
//增加預約
export const saveReserve = function (params = {}) {
  return axios.post(`/reserve/save`, params);
}
//获取门店的配置信息
export const getReserveConfig = function (params = {}) {
  return axios.post(`/reserve/getReserveConfig`, params);
}
//获取门店的配置信息
export const getReserveResourceInfo = function (params = {}) {
  return axios.post(`/reserve/getReserveResourceInfo`, params);
}
//获取员工的预约信息
export const getReserveInfo = function (params = {}) {
  return axios.post(`/reserve/getReserveInfo`, params);
}
//获取员工的预约信息
export const reserveCancel = function (params = {}) {
  return axios.post(`/reserve/cancel`, params);
}
//获取员工的预约
export const getMDateTimeFlag = function (params = {}) {
  return axios.post(`/reserve/getDateTimeFlag`, params);
}
//itemDiy 预约自由选择项目
export const reserveCategoryFreelyChoose = function (params = {}) {
  return axios.post(`/reserveCategory/fullInfoForServegroup`, params);
}
// 预约优惠信息查询
export const reserveCategoryDiscountFind = function (params = {}) {
  return axios.post(`/reserveCategory/getPayDiscount`, params);
}
// 预约优惠时间端折扣信息
export const reserveCategoryDiscountInfo = function (params = {}) {
  return axios.post(`/reserve/getDateDiscountInfo`, params);
}
// 预约在线支付页创建订单
export const reserveCategoryCreateOrder = function (params = {}) {
  return axios.post(`/reserveCategory/createOrder`, params);
}
// 取消预约明细信息
export const  cancelReserveFullInfo = function (params = {}) {
  return axios.post(`/reserve/getReserveFullInfo`, params);
}
// 取消预约退款规则
export const reserveRefundConfig = function (params = {}) {
  return axios.post(`/param/reserveRefundConfig`, params);
}
//员工的分店
export const myOrgIdList = function (params = {}) {
  return axios.post(`/staff/myOrgIdList`, params);
}
//员工的分店---不带树状结构
export const queryStaffOrgList = function (params = {}) {
  return axios.post(`/staff/queryStaffOrgList`, params);
}
//员工的分店,带层级结构
export const myTreeOrgIdList = function (params = {}) {
  return axios.post(`/org/myOrgList`, params);
}
// 根据员工ID获取员工名字
export const getStarffNameById = function (params = {}) {
  return axios.post(`/staff/getStaffName`, params);
}
//报表
export const getReport = function (params = {}) {
  return axios.post(`/report/summary`, params);
}


//检查是否是员工
export const staffcheck = function (params = {}) {

  return axios.post(`/staff/staffcheck`, params);
}
//营销分享
export const sharepluginList = function (params = {}) {
  return axios.post(`/plugin/list`, params);
}
export const sharepluginLink = function (params = {}) {
  return axios.post(`/plugin/getPluginUrl`, params, true);
}
export const sharepluginQrCode = function (params = {}) {
  return axios.post(`/plugin/getPluginQrCode`, params, true);
}

//员工业绩
export const summary = function (params = {}) {
  return axios.post(`/staffPerformance/summary`, params);
}
//员工业绩-汇总
export const staffReportSummary = function (params = {}) {
  return axios.post(`/staffPerformance/reportSummary`, params);
} //员工业绩-明细
export const staffReportList = function (params = {}) {
  return axios.post(`/staffPerformance/reportList`, params);
}
//营业报表-汇总
export const reportSummary = function (params = {}) {
  return axios.post(`/report/reportSummary`, params);
} 
//营业报表-汇总  new 
export const reportNewSummary = function (params = {}) {
  return axios.post(`/report/customizeBusinessReport/findReport`, params);
} 
//营业报表-明细
export const reportList = function (params = {}) {
  return axios.post(`/report/reportList`, params);
}
//微信红包提现
export const checkmemberstate = function (type, params = {}) {
  return axios.post(`extract/checkmemberstate/${type}`, params);
  //   return axios.post(`receivecash/checkmemberstate`, params);
}

//获取门店信息
export const orgGetorgname = function (orgId, params = {}) {
  return axios.post(`/org/getorgname/${orgId}`, params);
}

//获取门店信息
export const membercheck = function (params = {}) {
  return axios.post(`member/membercheck`, params);
}
//现金红包
export const getRedPackList = function (params = {}) {
  return axios.post(`receivecash/getRedPackList`, params);
}
export const receiveredpack = function (params = {}) {
  return axios.post(`receivecash/receiveredpack`, params);
}
export const getRedPack = function (params = {}) {
  return axios.post(`receivecash/manualWithdrawPayAction`, params);
}

//对账
export const getBill = function (params = {}) {
  return axios.post(`/plugin/bill`, params);
}
//营销方案员工销售汇总
export const staffPlankpi = function (planId, params = {}) {
  return axios.post(`/plugin/plankpi/staff/${planId}`, params);
}
//营销方案员工销售明细
export const staffSaleDetailList = function (params = {}) {
  return axios.post(`/plugin/plankpi/staffSaleDetailList`, params);
}
export const pluginOrderlist = function (params = {}) {
  return axios.post(`/plugin/orderlist`, params);
}
export const orderProcess = function (orderId, params = {}) {
  return axios.post(`/order/process/${orderId}`, params);
}


//微信授权签名
export const wxconfig = function (params = {}) {
  return axios.post(`/m/jsapi/wxconfig`, params);
}

//回访提醒列表
export const crmtasklist = function (params = {}) {
  return axios.post(`/crm/crmtasklist`, params, true);
}
//回访提醒发送
export const sendCrmVisitTaskInfo = function (params = {}) {
  return axios.post(`/crm/sendCrmVisitTaskInfo`, params, true);
}

//生日
export const birthdaynotify = function (params = {}) {
  return axios.post(`/crm/birthdaynotify`, params, true);
}
//生日发送礼物
export const sendBirthdayGift = function (params = {}) {
  return axios.post(`/crm/sendBirthdayGift`, params, true);
}

//拓客列表查询
export const todayexpmember = function (params = {}) {
  return axios.post(`/crm/todayexpmember`, params);
}
//拓客发送
export const sendcrmtoexpmember = function (params = {}) {
  return axios.post(`/crm/sendcrmtoexpmember`, params);
}
// 预约失败
export const getReserveFail = function (params = {}) {
    return axios.post(`/memberReport/reserveFail`, params);
}
// 休眠客--多久没到店会员
export const getDormant = function (params = {}) {
    return axios.post(`/memberReport/dormant`, params);
}
// 休眠客--超出回访
export const getOverPlan = function (params = {}) {
    return axios.post(`/memberReport/overPlan`, params);
}
// 购买未到店
export const getNoArrivel = function (params = {}) {
    return axios.post(`/memberReport/noArrivel`, params);
}


//增加会员手机号
export const saveMemberMobile = function (params = {}) {
  return axios.post(`/memberMobile/saveMemberMobile`, params);
}

//会员手机号码列表
export const memberMobileListList = function (params = {}) {
  return axios.post(`/memberMobile/list`, params, true);
}
//会员手机号码详情
export const getMemberMobileInfo = function (id, params = {}) {
  return axios.post(`/memberMobile/memberMobileInfo/${id}`, params);
}


//获取订单列表
export const getOrder = function (params = {}) {
  return axios.post(`/order/index`, params);
}
//获取订单列表
export const doCheckNumber = function (params = {}) {
  return axios.post(`/order/doCheckNumber`, params);
}

//收银
export const getTotalPaymentNoAccount = function (orderId, params = {}) {
  return axios.post(`/order/getTotalPaymentNoAccount/${orderId}`, params);
}
export const getOrderDetail = function (orderId, params = {}) {
  return axios.post(`/order/getOrderDetail/${orderId}`, params);
}

export const dropOrderLineById = function (orderLineId, params = {}) {
  return axios.post(`/order/dropOrderLineById/${orderLineId}`, params);
}

export const cancelPay = function (orderLineId, params = {}) {
  return axios.post(`/order/cancelPay/${orderLineId}`, params);
}
export const cashPay = function (orderLineId, params = {}) {
  return axios.post(`/order/cashPay/${orderLineId}`, params);
}
//获取订单价格信息
export const getOrderLineById = function (orderLineId, params = {}) {
  return axios.post(`/order/getOrderLineById/${orderLineId}`, params);
}
//保存订单价格信息
export const saveOrderLine = function (params = {}) {
  return axios.post(`/order/saveOrderLine`, params);
}
//获取订单员工
export const getLineStaffList = function (orderLineId, params = {}) {
  return axios.post(`/order/getLineStaffList/${orderLineId}`, params);
}
//获取员工角色
export const getLineStaffListGroupByRole = function (params = {}) {
  return axios.post(`/order/getLineStaffListGroupByRole`, params);
}
export const saveLineStaffList = function (orderLineId, params = {}) {
  return axios.post(`/order/saveLineStaffList/${orderLineId}`, params);
}
//支付方式
export const toModifyPaymentMethodftl = function (orderLineId, params = {}) {
  return axios.post(`/order/toModifyPaymentMethodftl/${orderLineId}`, params);
}
//保存支付方式
export const saveOrderLinePayment = function (orderLineId, params = {}) {
  return axios.post(`/order/saveOrderLinePayment/${orderLineId}`, params);
}
//获取套餐明细
export const getGroupInstanceById = function (orderLineId, params = {}) {
  return axios.post(`/order/getGroupInstanceById/${orderLineId}`, params);
}
//充值、交定金、退定金、还款 产生临时套餐明细 
export const genOtherInstAccountList = function (memberId, memberAccountId, optType, orderId, params = {}) {
  return axios.post(`/order/genOtherInstAccountList/${memberId}/${memberAccountId}/${optType}/${orderId}`, params);
}
//充值、交定金、退定金、还款 产生 生成订单
export const createOtherOrder = function (memberId, optType, params) {
  return axios.post(`/order/createOtherOrder/${memberId}/${optType}`, params);
}

//更新套餐明细
export const updategroupDetils = function (params = {}) {
  return axios.post(`/order/updategroupDetils`, params);
}
//添加账户
export const serveAccountTypeList = function (params = {}) {
  return axios.post(`/order/serveAccountTypeList`, params);
}
//选择项目
export const saleItemList = function (params = {}) {
  return axios.post(`/order/saleItemList`, params);
}
//千人千面模板新增保存
export const thousandFacesSave = function (params = {}) {
  return axios.post(`/formwork/saveFormwork`, params);
}
//千人千面模板预览
export const thousandFacesPreview = function (params = {}) {
  return axios.post(`/formwork/getFormwork`, params);
}
//千人千面模板 会员新增保存
export const thousandFacesMemberSave = function (params = {}) {
  return axios.post(`/formworkInstance/saveFormworkInstance`, params);
}
//千人千面模板 会员预览
export const thousandFacesMemberPvw = function (params = {}) {
  return axios.post(`/formworkInstance/getFormworkInstance`, params);
}
//千人千面模板 模板发送
export const thousandFacesSend = function (params = {}) {
  return axios.post(`/formworkInstance/sendToMember`, params);
}
//千人千面模板 实例发送
export const thousandFacesMemberSend = function (params = {}) {
  return axios.post(`/formworkInstance/sendToMemberUseInstance`, params);
}
//千人千面模板 会员购买
export const thousandFacesBuy = function (params = {}) {
  return axios.post(`/formworkInstance/submitBuy`, params);
}
//选择其他员工
export const mSelectOtherStoresStaff = function (params = {}) {
  return axios.post(`/order/selectOtherStoresStaff`, params);
}
//创建销售单
export const createSaleOrderByItemList = function (params = {}) {
  return axios.post(`/order/createSaleOrderByItemList`, params);
}
//继续购买
export const addOrderLineByItemIds = function (params = {}) {
  return axios.post(`/order/addOrderLineByItemIds`, params);
}

//订单添加消耗单
export const addAcctLine = function (params = {}) {
  return axios.post(`/order/addAcctLine`, params);
}
export const itemPackageByInstAcctId = function (instAcctId, params = {}) {
  return axios.post(`/order/itemPackageByInstAcctId/${instAcctId}`, params);
}



//投票说明
export const votecontentinfo = function (params = {}) {
  return axios.post(`/vote/votecontentinfo`, params, true);
}


//投票列表查询 vote/votelist
export const votelist = function (params = {}) {
  return axios.post(`/vote/votelist`, params, true);
}

// 投票活动明细
export const votedetail = function (params = {}) {
  return axios.post(`/vote/votedetail`, params, true);
}

//投票主页信息查询
export const voteparterinfo = function (params = {}) {
  return axios.post(`/vote/voteparterinfo`, params);
}

//投票报名
export const votesignin = function (params = {}) {
  return axios.post(`/vote/votesignin`, params, true);
}

//投票排行
export const voteranking = function (params = {}) {
  return axios.post(`/vote/voteranking`, params, true);
}



//投票人列表
export const votememberlist = function (params = {}) {
  return axios.post(`/vote/votememberlist`, params, true);
}

//投票
export const votetomember = function (params = {}) {
  return axios.post(`/vote/votetomember`, params, true);
}
//投票二维码
export const parterqrcode = function (params = {}) {
  return axios.post(`/vote/parterqrcode`, params, true);
}






export const delOrder = function (orderId, params = {}) {
  return axios.post(`/order/dropOrderById/${orderId}`, params);
}

//获取会员的背包
export const getOrdermemberAccount = function (memberId, params = {}) {
  return axios.post(`/order/getOrdermemberAccount/${memberId}`, params);
}

//划卡
export const scratchCard = function (params = {}) {
  return axios.post(`/order/scratchCard`, params);
}

//获取套餐里的项目
export const getMemberAccountItem = function (memberAccountId, params = {}) {
  return axios.post(`/order/itemPackage/${memberAccountId}`, params);
}
//工作台-》今日到店-》查询会员
export const getRegisterInfo = function (params = {}) {
  return axios.post(`/memReg/getRegisterInfo`, params);
}
//工作台-》今日到店-》查询组织或未购买店务的门店  隐藏
export const getOrganOrStore = function (params = {}) {
  return axios.post(`org/checkPlatformActive`, params);
}
//工作台-》今日到店-》二维码
export const getWxqrcode = function (orgId) {
  return axios.post(`/org/wxqrcode/${orgId}`);
}
//工作台-》今日到店-》手工签到
export const addMemReg = function (params) {
  return axios.post('/memReg/add', params);
}
//工作台-》今日到店-》手工签到
export const votedone = function (voteid) {
  return axios.post(`/vote/votefinish/votedone/${voteid}`);
}

//门店列表
export const shopList = function (params) {
  return axios.post(`/org/list`, params);
}
export const treelist = function (params) {
  return axios.post(`/org/treelist`, params);
}
//新增门店
export const createShop = function (params) {
  return axios.post(`/org/create`, params);
}
//字典
export const orgDicdata = function (params) {
  return axios.get(`/combox/${params}/dictdata`);
}
export const orgType = function (params) {
  return axios.get(`/org/dicdata/${params}`);
}
//员工列表
export const staffList = function (params) {
  return axios.post(`/staff/list`, params);
}
//获取邀请链接
export const staffLink = function (params) {
  return axios.post(`/staff/getinviteurl`, params);
}
export const allDictDataByCodes = function (dictCodes) {
  return axios.get(`/combox/${dictCodes}/allDictDataByCodes`);
}


//编辑员工
export const saveMainRecord = function (params) {
  return axios.post(`/staff/save`, params);
}
//删除员工
export const delMainRecord = function (params) {
  return axios.post(`/staff/drop`, params);
}
//编辑门店 
export const updateShop = function (params) {
  return axios.post(`/org/update`, params);
}
//拓客列表
export const tuokerList = function (params) {
  return axios.post(`/tuoker/list`, params);
}
//拓客详情
export const tuokerDetail = function (tuokerId, params = {}) {
  return axios.post(`/tuoker/detail/${tuokerId}`, params);
}
//拓客新增编辑
export const tuokerUpdate = function (params) {
  return axios.post(`/tuoker/updateitem`, params);
}
//拓客删除
export const delTuoker = function (tuokerId) {
  return axios.post(`/tuoker/deleteitem/${tuokerId}`);
}
//话术列表
export const speechList = function (params) {
  return axios.post(`/commonDiscourse/list`, params);
}
//套餐列表
export const packageList = function (params) {
  return axios.post(`/tuoker/itemlist`, params);
}

//报名定义详情
export const pluginSignupInfoByPluginId = function (params) {
  return axios.post(`/pluginSignup/infoByPluginId`, params, true);
}


//报名人数列表
export const pluginSignupMemberListPage = function (params) {
  return axios.post(`/pluginSignup/memberListPage`, params, true);
}


//提交报名
export const pluginSignupSubmit = function (params) {
  return axios.post(`/pluginSignup/submit`, params, true);
}


//获取支付后二维码
export const orderdoneqrcode = function (orgId, params) {
  return axios.post(`/org/orderdoneqrcode/${orgId}`, params);
}

//删除门店
export const delShop = function (params) {
  return axios.post(`/org/delete`, params);
}
//重置密码
export const resetPwd = function (params) {
  return axios.post(`/staff/resetPwd`, params);
}
//校验
export const checkUrl = function (params) {
  return axios.post(`/org/checkinviteshareurl`, params);
}
//代理商  我的客户 门店信息   
export const orgInfo = function (params) {
  return axios.post(`/org/info`, params);
}

//客户组织授权信息
export const getAuthorizerInfo = function (params) {
  return axios.post(`/org/getAuthorizerInfo`, params);
}
//客户组织微信模版消息列表
export const getOrgTemplates = function (params) {
  return axios.post(`/org/findalltemplates`, params);
}
//客户组织微信设置模版消息
export const settemplateindustry = function (params) {
  return axios.post(`/org/settemplateindustry`, params);
}
//客户组织微信同步模板消息
export const defaultsyncwxtemplateinfo = function (params) {
  return axios.post(`/org/defaultsyncwxtemplateinfo`, params);
}
//客户组织微信删除模板消息
export const deleteOrgTemplate = function (params) {
  return axios.post(`/org/deleteTemplate`, params);
}




//微信分享配置
export const jsapiWxconfig = function (params) {
  return axios.post(`/m/jsapi/wxconfig`, params, true);
}

//微信分享
export const twShare = function (params) {
  return axios.post(`/tw/share`, params, true);
}
//微信阅读
export const twRead = function (params) {
  return axios.post(`/tw/read`, params, true);
}


//获取服务评价内容
export const serviceCommentFullInfo = function (params) {
  return axios.post(`/pluginServiceComment/serviceCommentFullInfo`, params);
}
//获取服务评价内容
export const submitServiceComment = function (params) {
  return axios.post(`/pluginServiceComment/submitComment`, params);
}
// export const getEvaluteQrcode = function (params) {
//     return axios.post(`/pluginServiceComment/submitComment`, params);
// }


//服务评价列表
export const getServiceComment = function (params) {
  return axios.post(`/pluginServiceComment/serviceCommentMemberPage`, params);
}
//服务评价权限
export const serviceCommentPermission = function (params) {
  return axios.post(`/staff/hasPermission`, params);
}
//营销方案-详情
export const getPlankpiByPlanId = function (planId, params = {}) {
  return axios.post(`/plugin/plankpiByPlanId/${planId}`, params);
}
//营销方案-红包详情
export const getPlankpiByRedPacketId = function (planId, params = {}) {
  return axios.post(`/plugin/plankpiForRedPacketByPlanId/${planId}`, params);
}


//待审核代理列表
export const waitApproveAgentList = function (params = {}) {
  return axios.post(`/agentUser/waitApproveAgentList`, params);
}
//代理审核
export const approveAgent = function (params = {}) {
  return axios.post(`/agentUser/approveAgent`, params);
}
//我的代理
export const myAgentList = function (params = {}) {
  return axios.post(`/agentUser/myAgentList`, params);
}

//我的同事
export const myColleaguesList = function (params = {}) {
  return axios.post(`/agentUser/myColleaguesList`, params);
}

//待审核同事列表破
export const waitApproveColleaguesList = function (params = {}) {
  return axios.post(`/agentUser/waitApproveColleaguesList`, params);
}
//审核同事
export const approveColleagues = function (params = {}) {
  return axios.post(`/agentUser/approveColleagues`, params);
}
//获取代理信息
export const getAgentInfo = function (params = {}) {
  return axios.post(`/agentUser/getAgentInfo`, params);
}
export const getColleagues = function (params = {}) {
  return axios.post(`/agentUser/getColleagues`, params);
}
//获取我的->代理商首页 客户信息
export const getCustomerList = function (params = {}) {
  return axios.post(`/agentUser/getCustomerList`, params);
}
//获取我的->代理商子级   客户信息
export const getCustomerSubList = function (customerId, params = {}) {
  return axios.post(`/agent/getCustomerOrgInfoList?orgId=${customerId}`, params);
}

//获取我的->代理商   的客户 店务营销价格
export const agentCustomer = function (params = {}) {
  return axios.post(`/agentUser/getCustomer`, params);
}
//更换下一个
export const getCustomerOrgList = function (customerId, params = {}) {
  return axios.post(`/agent/getCustomerOrgList?customerId=${customerId}`, params);
}
//客户信息详情
export const getCustomerListDetail = function (params = {}) {
  return axios.post(`agent/orgItemList`, params);
}
//添加门店   修改门店
export const getCustomerListAdd = function (params = {}) {
  return axios.post(`org/saveChain`, params);
}
//点击下一步创建订单
export const getCustomerCreaterOrder = function (params = {}) {
  return axios.post(`/agent/createOrder`, params);
}
//确认支付订单信息
export const getCustomerOrderDetail = function (params = {}) {
  return axios.post(`/agent/orderFullInfo`, params);
}
//确认余额支付
export const getCustomerBalancePay = function (params = {}) {
  return axios.post(`agent/payFinishedBymlzx`, params);
}
//0元订单执行确认支付
export const getCustomerPayFinished = function (params = {}) {
  return axios.post(`agent/payFinished`, params);
}
//支付成功提示信息
export const getCustomerPaySuccessInfo = function (params = {}) {
  return axios.post(`agent/paySuccessInfo`, params);
}


export const saveCustomer = function (params = {}) {
  return axios.post(`/agentUser/saveCustomer`, params);
}
export const registerColleagues = function (params = {}) {
  return axios.post(`/agentUser/registerColleagues`, params);
}


//检查是否是代理商
export const agentCheck = function (params = {}) {
  return axios.post(`/agent/check`, params);
}
//检查是否是一级代理
export const agentCheckMlzx = function (params = {}) {
  return axios.post(`/agentUser/checkMlzxStaff`, params);
}
//创建充值订单
export const agentOrder = function (params = {}) {
  return axios.post(`/agentOrder/createagentrecharge`, params);
}
//代理商平台邀请 -提交
export const agentUserSave = function (params = {}) {
  return axios.post(`/agentUser/saveAgent`, params);
}
//余额，提现明细
export const getAgentDetail = function (params = {}) {
  return axios.post(`/agent/agentTransation`, params);
}
//余额，可提现的金额
export const getAgentAmount = function (params = {}) {
  return axios.post(`/agent/agentBalance`, params);
}
//代理商提现前校验
export const checkAgentWithdraw = function (params = {}) {
  return axios.post(`/agent/checkAgentWithdraw`, params);
}
//代理商提现保存
export const doAgentWithdraw = function (params = {}) {
  return axios.post(`/agent/agentWithdraw`, params);
}
//支付宝账户信息
export const agentAlipayAccount = function (params = {}) {
  return axios.post(`/agent/getWithdrawLastData`, params);
}
//daodian huiyuan
export const fileUploadImg = function (params = {}) {

  return axios.file(`picresource/xupload`, params, true);
}
//daodian huiyuan   Base64
export const fileUploadImgBase = function (params = {}) {

  return axios.post(`/picresource/uploadBase64`, params);
}


export const getAgentRegisterUrl = function (params = {}) {
  return axios.post(`/agentUser/getAgentRegisterUrl`, params);
}
export const getColleaguesRegisterUrl = function (params = {}) {
  return axios.post(`/agentUser/getColleaguesRegisterUrl`, params);
}


export const getCustomerMiniCode = function (params = {}) {

  return axios.post(`/agentUser/getCustomerMiniCode`, params);
}
export const getMiniAdminRegisterCode = function (params = {}) {
  return axios.post(`/org/getMiniAdminRegisterCode`, params);
}
// 代理商 -- 门店或组织购买项列表
export const getAgentItemList = function (params = {}) {
  return axios.post(`/agentItem/getList`, params);
}

export const delColleagues = function (params = {}) {
  return axios.post(`/agentUser/delColleagues`, params);
}
export const updateColleagues = function (params = {}) {
  return axios.post(`/agentUser/updateColleagues`, params);
}
export const agentRecharge = function (params = {}) {
  return axios.post(`/agentUser/recharge`, params);
}
export const updateAgent = function (params = {}) {
  return axios.post(`/agentUser/updateAgent`, params);
}
export const checkMlzxStaff = function (params = {}) {
  return axios.post(`/agentUser/checkMlzxStaff`, params);
}

export const createAuthPage = function (id, params = {}) {
  return axios.get(`/m/auth/createAuthPage?orgId=${id}`, params);
}

export const getStaffState = function (params = {}) {
  return axios.post(`/staff/getStaffInfo`, params);
}
//获取验证码
export const getVerCode = function (params = {}) {
  return axios.post(`/member/getverificationcode`, params)
}
// 会员资料绑定
export const getBindMemeber = function (params = {}, pas = {}) {
  return axios.post(`/member/bindMember/`, params, pas)
}

// 代理商选择项目生成订单明细行
export const agentCreateOrderLine = function (params = {}) {
  return axios.post(`/agentOrder/createOrderLine`, params);
}

// 未支付订单列表明细
export const getUnPayOrderLine = function (params = {}) {
  return axios.post(`/agentOrder/getUnPayOrderLine`, params);
}

//未支付订单列表明细删除
export const deleteOrderLine = function (params = {}) {
  return axios.post(`/agentOrder/deleteOrderLine`, params);
}
export const consumeRecord = function (params = {}) {
  return axios.post(`/organizationPrinter/consumeRecord`, params);
}
// 以付款订单信息（分页）
export const getPayOrder = function (params = {}) {
  return axios.post(`/agentOrder/getPayOrder`, params);
}
//未支付订单列表明细 勾选 
export const unPayJump = function (params = {}) {
  return axios.post(`/agentOrder/createOrderByLine`, params);
}
//打印小票
export const printCase = function (params = {}) {
  return axios.post(`/agentOrder/createOrderByLine`, params);
}
//获取当前组织下的门店包含距离
export const orgList = function (params = {}) {
  return axios.post(`/org/list`, params,true).then(res => res.data.data.result)
}
//获取当前组织下的门店包含距离
export const reserveCategoryList = function (params = {}) {
  return axios.post(`/reserveCategory/list`, params,true).then(res => res.data.data)
}
// export const reserveCategoryList = function (params = {}) {
//   // return axios.post(`/reserveCategory/list`, params).then(res => res.data.data)
// }
// 保存订单签名 (公众号)
export const saveJieSuanSignature = function (params = {}) {
  return axios.post(`/orderSign/save`, params, true)
}
// 查询订单签名图像 "orderId":111  //订单id 
export const getOrderSign  = function(params = {}) {
  return axios.post(`/orderSign/getOrderSign`,params);
}
// 发送签名模版  "orderId":111  //订单id 
export const sendOrderSign  = function(params = {}) {
  return axios.post(`/order/sendOrderSign`,params);
}

// 封面图片分页查询          /formworkPicture/list
export const getFaceImgByPage  = function(params = {}) {
  return axios.post(`/formworkPicture/list`,params);
}
// 上传封面图片          /formworkPicture/upload  
export const faceImgUpload  = function(params = {}) {
  return axios.post(`/formworkPicture/upload`,params);
}
// 上传封面图片 H5         /formworkPicture/mobileUpload  uploadImage:(图像文件)
export const mobileUpload  = function(params = {}) {
  return axios.post(`/formworkPicture/mobileUpload`,params);
}

// 查看红包配置 参数id、lat、lon(经纬度)
export const getRedPacketConfig  = function(id, params = {}) {
  return axios.post(`pluginRedPacket/getFullInfo/${id}`,params);
}
// 领取红包 参数id、lat、lon(经纬度)
export const openRedPacket = function(id, params = {}) {
  return axios.post(`pluginRedPacket/received/${id}`,params);
}
// 查看红包领取记录 参数 分页参数 redPacketId(红包id)
export const getRedPacketRecord  = function(params = {}) {
  return axios.post(`pluginRedPacket/receivedList`,params);
}
// 营销分享红包
export const getMarketingRedPacket  = function(params = {}) {
  return axios.post(`/pluginRedPacket/recordList`,params);
}
// 营销分享红包充值
export const redPacketRecharge  = function(params = {}) {
  return axios.post(`/pluginRedPacket/recharge`,params);
}
   // 获取商城分类
export const getPuginShoppingCategoryLists  = function(params = {}) {
  return axios.post(`/pluginShoppingCategory/list`,params);
}
// 秒杀获取个人红包返现
export const getOneMemberCashback  = function(params = {}) {
  return axios.post(`/seckill/getOneMemberCashback`,params);
}
// 秒杀获取红包列表
export const getSeckillMemberCashbackList  = function(params = {}) {
  return axios.post(`/seckill/getSeckillMemberCashback`,params);
}
// 拓客获取个人红包返现
export const getTuokeOneMemberCashback  = function(params = {}) {
  return axios.post(`/pluginExpcustomer/getOneMemberCashback`,params);
}
// 拓客获取红包列表
export const getExpcustomerMemberCashback  = function(params = {}) {
  return axios.post(`/pluginExpcustomer/getExpcustomerMemberCashback`,params);
}
// 修改备注
export const editRemark  = function(orderHeaderId, params = {}) {
  return axios.post(`/order/modiRemark/${orderHeaderId}`,params);
}
// 我的客户 接口
// 过滤条件
export const getTagsData  = function(params = {}) {
  return axios.post(`/memberCategory/tagsData`,params);
}
// 顶部跟进员工列表
export const getfollowStaffList  = function(params = {}) {
  return axios.post(`/memberCategory/followStaffList`,params);
}
// 目标会员列表
export const gettargetMemberList = function(params = {}) {
  return axios.post(`memberCategory/targetMemberList`,params);
}
// 会员归类-分类列表
export const getcategoryList  = function(params = {}) {
  return axios.post(`memberCategory/categoryList`,params);
}
// 会员归类-会员列表(分页)
export const getCategoryMemberList = function(params = {}) {
  return axios.post(`memberCategory/memberList`,params);
}
// 添加会员给自己
export const addMemberToFollow  = function(params = {}) {
  return axios.post(`memberCategory/addMemberToFollow`,params);
}
// 把会员分享给其它同事
export const shareMember  = function(params = {}) {
  return axios.post(`memberFollowShare/receiveMember`,params);
}
// 会员跟进业绩历史
export const getmemberTargetList = function(params = {}) {
  return axios.post(`/memberTarget/memberTargetList`,params);
}
// 标签列表
export const getmemberTagList  = function(params = {}) {
  return axios.post(`/member/memberTagList`,params);
}
// 保存标签
export const saveMemberTag  = function(params = {}) {
  return axios.post(`/member/saveMemberTag`,params);
}
// 目标详情
export const getTargetInfo  = function(params = {}) {
  return axios.post(`/memberTarget/info`,params);
}
// 新增和修改 目标
export const saveTarget  = function(params = {}) {
  return axios.post(`/memberTarget/save`,params);
}
// 删除目标
export const deleteTarget  = function(params = {}) {
  return axios.post(`/memberTarget/delete`,params);
}
// 目标详情 包含备注
export const getfullInfo  = function(params = {}) {
  return axios.post(`/memberTarget/fullInfo`,params);
}
// 新增和修改 备注
export const saveBackup  = function(params = {}) {
  return axios.post(`/memberTarget/saveBackup`,params);
}
// 删除目标备注
export const deleteBackup  = function(params = {}) {
  return axios.post(`/memberTarget/deleteBackup`,params);
} 
// 删除会员
export const deleteMemberFollow  = function(params = {}) {
  return axios.post(`/memberCategory/deleteMemberFollow`,params);
} 
// 把会员分享给其它同事
export const shareMemberToOtherStaff  = function(params = {}) {
  return axios.post(`/memberFollowShare/shareForStaff`,params);
} 
// 查看分享数据 
export const getShareInfo  = function(params = {}) {
  return axios.post(`/memberFollowShare/fullInfo`,params);
} 
// 确认接受其他同事分享的会员
export const receiveShareMember  = function(params = {}) {
  return axios.post(`/memberFollowShare/receiveMember`,params);
} 
// 移动端 员工列表 分页参数、type:11(表示员工)
export const getStaffList  = function(params = {}) {
  return axios.post(`/staff/staffList`,params);
} 
// 调整跟进人 参数 followId(即目标会员列表的id)、staffId(重新选择的员工id) 完成回到列表页面刷新数据
export const changeFollowStaff  = function(params = {}) {
  return axios.post(`/memberCategory/changeFollowStaff`,params);
} 

// ## H5到店用户列表
// ylk/arriveList
// 参数 ：分页参数、start_date、end_date 如果start_date、end_date没传表示查当天的
export const ylkArriveList  = function(params = {}) {
  return axios.post(`/ylk/arriveList`,params);
} 

// ## H5保存悠络客会员绑定，ylkUserId为空表示要解绑
// member/saveMemberYlk
// memberId, ylkUserId, ylkImgurl
export const relateMemberYlk  = function(params = {}) {
  return axios.post(`/member/saveMemberYlk`,params);
} 

// ## H5到店某个会员的人脸识别列表
// member/memberArriveList
// 参数 ：分页参数、memberId
export const memberYlkArriveList  = function(params = {}) {
  return axios.post(`/member/memberArriveList`,params);
} 

// ## H5会员主头像设定
// member/setMainHeadimgurl
// 参数 memberId、imgurl
export const setMainHeadimgurl  = function(params = {}) {
  return axios.post(`/member/setMainHeadimgurl`,params);
} 





// WEBPACK FOOTER //
// ./src/assets/js/request.js